import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export interface StatItem {
  label: string;
  value: string | number;
  color?: string;
}

@Component({
  selector: 'app-stat-group',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="stat-group">
      @for (stat of items(); track stat.label) {
        <div class="stat-group__item">
          <div class="stat-group__label">{{ stat.label }}</div>
          <div class="stat-group__value" [style.color]="stat.color || null">{{ stat.value }}</div>
        </div>
      }
    </div>
  `,
  styles: `
    :host {
      display: flex;
    }
    .stat-group {
      display: flex;
      gap: 1.75rem;
    }
    .stat-group__item {
      text-align: center;
    }
    .stat-group__label {
      font-size: 0.6875rem;
      font-weight: 600;
      color: var(--to-text-muted, #6b7280);
      letter-spacing: 0.06em;
      text-transform: uppercase;
    }
    .stat-group__value {
      font-size: 1.625rem;
      font-weight: 700;
      color: var(--to-text-strong, #111827);
      letter-spacing: -0.02em;
      font-variant-numeric: tabular-nums;
      margin-top: 0.125rem;
    }
  `,
})
export class StatGroupComponent {
  readonly items = input.required<StatItem[]>();
}
